import { MRT_RowSelectionState } from 'mantine-react-table';
import React, { useEffect, useState } from 'react';
import { MeetingListDto } from 'src/api/FiretrolApiClient';
import { MeetingTable } from 'src/routes/Jobs/MeetingMinutes/components/MeetingsTable/index';

export interface ISelectableMeetingTableProps {
  meetings: MeetingListDto[];
  caption?: string;
  selectedMeetingId?: string | null;
  isLoading?: boolean;
  onMeetingSelected: (meeting: MeetingListDto) => void;
}

export const SelectableMeetingTable: React.FC<ISelectableMeetingTableProps> = ({
  meetings,
  caption,
  selectedMeetingId,
  isLoading = false,
  onMeetingSelected,
}) => {
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  useEffect(() => {
    // Find the selected meeting and call onMeetingClicked
    const selectedRowId = Object.keys(rowSelection)[0];
    if (selectedRowId) {
      const selectedMeeting = meetings.find(
        (meeting) => meeting.id === selectedRowId,
      );
      if (selectedMeeting) {
        onMeetingSelected(selectedMeeting);
      }
    }
  }, [rowSelection]);

  return (
    <MeetingTable
      meetings={meetings}
      caption={caption}
      selectedMeetingId={selectedMeetingId}
      isLoading={isLoading}
      tableOptions={{
        positionToolbarAlertBanner: 'none', //don't show the toolbar alert banner
        enableRowActions: false,
        enableRowSelection: true,
        enableSelectAll: false,
        enableMultiRowSelection: false,
        onRowSelectionChange: setRowSelection,
      }}
      tableProps={{
        rowSelection: rowSelection,
      }}
    />
  );
};
